import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { WhatsappTransport } from "@school-sales-ai/shared";
import { api } from "@/lib/api";

export type WhatsAppStatus = {
  connected: boolean;
  phone: string | null;
  connectedSince: string | null;
  transport: WhatsappTransport;
};

export function useWhatsAppStatus() {
  return useQuery({
    queryKey: ["whatsapp-status"],
    queryFn: () => api.get<WhatsAppStatus>("/crm/whatsapp/status"),
    refetchInterval: 10_000,
  });
}

export function useDisconnectWhatsApp() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.post<{ ok: true }>("/crm/whatsapp/logout", {}),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["whatsapp-status"] });
    },
  });
}
